import { render } from "./DialogSaveImageError.vue?vue&type=template&id=52dd56fa&scoped=true"
import script from "./DialogSaveImageError.vue?vue&type=script&lang=js"
export * from "./DialogSaveImageError.vue?vue&type=script&lang=js"

import "./DialogSaveImageError.vue?vue&type=style&index=0&id=52dd56fa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52dd56fa"]])

export default __exports__